module.exports = __webpack_public_path__ + "img/license_image3.ec29ebbb.png";